exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offerta-comment{height:90px;width:100%}.price{font-size:30px}@media (min-width:769px){.offerta-comment{width:580px}}", ""]);

// exports
